export default __webpack_public_path__ + "assets/ms-icon-310x310.c5b40bb4763d6df975b06bdc246064a9.png";